module.exports = __webpack_public_path__ + "static/media/alert-light.30174e74.svg";